import {FormControl} from '@angular/forms';

export function isFormControlInvalid(control:FormControl, submitButtonClicked:boolean) {
  // return control.invalid && (control.dirty || control.touched)
  return control.invalid && submitButtonClicked;
}
